export default __webpack_public_path__ + "static/media/logo-gp--white.6c3ff5bb.svg";